/* index.tsx generated by @compiled/babel-plugin v2.0.0 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._00uqCY98eZ%7Btext-decoration-color%3AcurrentColor%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3xtjKNYbGa%7Btext-decoration-line%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0H9qDF6wH8%7Btext-decoration-style%3Asolid%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1UtDYzZpcK%7Bcolor%3Avar(--ds-text-subtle%2C%23505258)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0clgaMZpcK%3Ahover%7Bcolor%3Avar(--ds-text-subtle%2C%23505258)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1UtDYze5R3%7Bcolor%3Avar(--ds-text-inverse%2C%23fff)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0DCa9D98eZ%3Ahover%7Btext-decoration-color%3AcurrentColor%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3932vv0Rl6%3Ahover%7Btext-decoration-line%3Aunderline%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._02cRtH6wH8%3Ahover%7Btext-decoration-style%3Asolid%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0clgaMe5R3%3Ahover%7Bcolor%3Avar(--ds-text-inverse%2C%23fff)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDKxmn%7Bborder-radius%3Avar(--ds-radius-small%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02xpxF%7Bwidth%3A9pt%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VxpxF%7Bheight%3A9pt%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._00EA0eiObl%7B-o-object-fit%3Acover%3Bobject-fit%3Acover%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3YEZNOdnbC%7Bflex-shrink%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbvLZJ%7Bdisplay%3Ablock%7D");
import React, { useRef } from 'react';
import FileIcon from '@atlaskit/icon/core/file';
import ImageIcon from '@atlaskit/icon/core/image';
import LinkIcon from '@atlaskit/icon/core/link';
import PageIcon from '@atlaskit/icon/core/page';
import PagesIcon from '@atlaskit/icon/core/pages';
import StoryIcon from '@atlaskit/icon/core/story';
import WhiteboardIcon from '@atlaskit/icon/core/whiteboard';
import { Anchor, Box, Inline, Text } from '@atlaskit/primitives/compiled';
import type { Conversation } from '../../../types';
const styles = {
  scopeLink: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _1UtDYzZpcK _0clgaMZpcK",
  scopeLinkTooltip: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _1UtDYze5R3 _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMe5R3",
  scopeLinkIconImage: "_0bjKvDKxmn _39xV02xpxF _0jFU0VxpxF _00EA0eiObl _3YEZNOdnbC _3iDTPbvLZJ"
};
export type ScopeRowVariant = 'default' | 'tooltip';
type ConversationScope = NonNullable<Conversation['scopes']>[number];
type ScopeRowScope = Omit<ConversationScope, 'link'> & {
  link: ConversationScope['link'] | undefined;
};
function getScopeIconComponent(scope: ScopeRowScope, showLinkFallbackIcon: boolean): typeof PageIcon | null {
  switch (scope.type) {
    case 'image':
      return ImageIcon;
    case 'file':
      return FileIcon;
    case 'jira':
      return StoryIcon;
    case 'confluence':
      switch (scope.sub_type) {
        case 'space':
          return PagesIcon;
        case 'whiteboard':
          return WhiteboardIcon;
        case 'page':
        default:
          return PageIcon;
      }
    case 'link':
      return showLinkFallbackIcon ? LinkIcon : null;
    default:
      return null;
  }
}
export type ScopeRowProps = {
  scope: ScopeRowScope;
  variant: ScopeRowVariant;
  maxLines: number;
  /** Whether to render the scope title beside its icon. Defaults to true. */
  showName?: boolean;
  /** Whether links without a remote icon use the generic link icon. Defaults to false. */
  showLinkFallbackIcon?: boolean;
  /** Whether to render the icon when the scope is not linked. Defaults to false. */
  showIconWithoutLink?: boolean;
  onFilePreview?: (link: string, name: string) => void;
  onScopeLinkClick?: (variant: ScopeRowVariant) => void;
  onScopeLinkHover?: () => void;
};

/**
 * Renders a single scope as an icon + name wrapped in an anchor.
 * Used in both the first-scope footer and in the tooltip scope list.
 *
 * Shared between `ChatItem` (conversation-assistant-ui-components) and
 * `ChatListItem` (rovo-navigation).
 */
export const ScopeRow = ({
  scope,
  variant,
  maxLines,
  showName = true,
  showLinkFallbackIcon = false,
  showIconWithoutLink = false,
  onFilePreview,
  onScopeLinkClick,
  onScopeLinkHover
}: ScopeRowProps): JSX.Element => {
  const textColor = variant === 'tooltip' ? 'color.text.inverse' : 'color.text.subtlest';
  const iconColor = variant === 'tooltip' ? "var(--ds-icon-inverse, #FFFFFF)" : "var(--ds-icon-subtle, #505258)";
  const isFile = scope.type === 'file' || scope.type === 'image';
  const canUseIconUrl = scope.type === 'link' || scope.type === 'jira';
  const ScopeIcon = getScopeIconComponent(scope, showLinkFallbackIcon);
  const hasRemoteScopeIcon = canUseIconUrl && typeof scope.icon_url === 'string' && scope.icon_url.trim().length > 0;

  // Prefer a remote `icon_url` (links / jira) when present; otherwise fall back to the built-in icon.
  const icon = hasRemoteScopeIcon ? <Box as="img" src={scope.icon_url} alt={showName ? '' : scope.name} xcss={styles.scopeLinkIconImage} /> : ScopeIcon ? <ScopeIcon label={showName ? '' : scope.name} size="small" color={iconColor} /> : null;

  // Defensively resolve `link` to a string — the API may return an object or
  // null/undefined for freshly-pasted links before backend normalisation.
  const rawLink = (scope.link as unknown);
  const resolvedLink = typeof rawLink === 'string' ? rawLink : rawLink !== null && typeof rawLink === 'object' ? String((rawLink as Record<string, unknown>).url ?? (rawLink as Record<string, unknown>).href ?? '') : '';

  // Guard: fire the hover analytics event only once per mouseenter/mouseleave
  // cycle, regardless of how many synthetic mouseenter events the browser emits.
  const hasHoveredRef = useRef(false);
  const handleMouseEnter = () => {
    if (!hasHoveredRef.current) {
      hasHoveredRef.current = true;
      onScopeLinkHover?.();
    }
  };
  const handleMouseLeave = () => {
    hasHoveredRef.current = false;
  };
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onScopeLinkClick?.(variant);
    if (isFile && onFilePreview) {
      e.preventDefault();
      onFilePreview(resolvedLink, scope.name);
    }
  };
  if (!resolvedLink) {
    return <Inline alignBlock="center" space="space.050">
				{showIconWithoutLink && icon}
				{showName && <Text size="small" weight="regular" maxLines={maxLines} align="start" color={textColor}>
						{scope.name}
					</Text>}
			</Inline>;
  }
  return <Inline alignBlock="center" space="space.050">
			<Anchor href={resolvedLink} aria-label={showName ? undefined : scope.name} {...isFile ? {} : {
      target: '_blank',
      rel: 'noreferrer'
    }} xcss={variant === 'tooltip' ? styles.scopeLinkTooltip : styles.scopeLink} onClick={handleClick} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
				<Inline alignBlock="center" space="space.050">
					{icon}
					{showName && <Text size="small" weight="regular" maxLines={maxLines} align="start" color={textColor}>
							{scope.name}
						</Text>}
				</Inline>
			</Anchor>
		</Inline>;
};